import React, { useState } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import { Button } from '.';

const SplitButton = ({
	containerClassName,
	title,
	onClick,
	items,
	right = false,
	...buttonProps
}) => {
	const [isOpen, setOpen] = useState(false);

	const handleToggle = () => {
		setOpen(!isOpen);
	};

	const handleItemClick = (evt, itemIndex) => {
		evt.preventDefault();
		items[itemIndex].onClick();
		setOpen(false);
	};

	return (
		<div className={cn('btn-group', containerClassName, { open: isOpen })}>
			<Button {...buttonProps} title={title} onClick={onClick} />
			<Button {...buttonProps} onClick={handleToggle} toggle />
			<ul
				role="menu"
				className={cn('dropdown-menu', { 'dropdown-menu-right': right })}
			>
				{items.map((item, index) => (
					<li key={item.title}>
						<a href="#" onClick={(evt) => handleItemClick(evt, index)}>
							{item.title}
						</a>
					</li>
				))}
			</ul>
		</div>
	);
};

SplitButton.propTypes = {
	containerClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
	title: PropTypes.string,
	onClick: PropTypes.func,
	items: PropTypes.array,
	right: PropTypes.bool,
};

export default SplitButton;
